import { createFileRoute } from '@tanstack/react-router';

import { AccountSettingsPage } from '@/features/identity';

/** Who you are here, and where Settings opens (spec 239). */
export const Route = createFileRoute('/settings/account')({
  component: AccountSettingsPage,
});
